import React from 'react';
import Row from 'components/common/Row';
import { useNavigate } from 'react-router-dom';
import CommonImage from 'components/common/CommonImage';
import { ICON_FRIP_LOGO } from 'assets/icons';
import { Product } from 'types/api';
import StatusButton from 'containers/ProductList/components/StatusButton';
import Text from 'components/common/Text';
import IconClose from 'assets/icons/IconClose';
import { PRODUCT_LIST_PATH } from 'constants/path';

interface ProductDetailHeaderIProps {
  productInfo: Product;
}

const ProductDetailHeader: React.FC<ProductDetailHeaderIProps> = props => {
  const { productInfo } = props;

  const navigate = useNavigate();

  const handleNavigateBack = () => {
    navigate(PRODUCT_LIST_PATH);
  };

  return (
    <Row
      style={{
        position: 'sticky',
        top: 0,
        left: 0,
        width: '100%',
        background: '#414B56',
      }}
    >
      <Row
        justifyContent="flex-end"
        style={{
          padding: '16px 0',
          width: '100%',
          maxWidth: '1200px',
        }}
      >
        <Row
          gap="6px"
          style={{ cursor: 'pointer' }}
          onClick={handleNavigateBack}
        >
          <Text color="#fff" size="16px" weight={600}>
            상품 수정 나가기
          </Text>
          <IconClose color="#fff" style={{ width: '24px', height: '24px' }} />
        </Row>
        {/* <StatusButton status={productInfo.status} /> */}
      </Row>
    </Row>
  );
};

export default ProductDetailHeader;
